
export default class shopifyFetchApi {
  sendData (url, data, method) {
    if (!window.Shopify) {
      console.log('not on Shopify site')
      return
    }
    fetch(url, {
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
      },
      method: 'POST'
    }).then(function (response) {
      console.log('response', response)
    }).then(function (json) {
          /* we have JSON */
    }).catch(function (err) {
          /* uh oh, we have error. */
      console.error(err)
    })
  }

  * getData (url) {
    if (!window.Shopify) {
      console.log('not on Shopify site')
      return null
    }
    const response = yield fetch(url, {
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
      },
      method: 'GET'
    })
    try {
      const json = yield response.json()
      return json
    } catch (e) {
      console.log(e)
      return null
    }
  }

  addToCart (id, quantity) {
    const url = '/cart/add.js'
    const data = {
      quantity,
      id: parseInt(id)
    }
    this.sendData(url, data)
  }

  updateCart (id, quantity) {
    const url = 'cart/update.js'
    const data = { updates: {
      [parseInt(id)]: quantity
    }
    }
    this.sendData(url, data)
  }

  deleteFromCart (id) {
    this.updateCart(id, 0)
  }

  clearCart () {
    const url = '/cart/clear.js'
    this.sendData(url, {})
  }

  * getCart () {
    const url = '/cart.js'
    const cart = yield this.getData(url)
    return cart
  }
}



// WEBPACK FOOTER //
// ./src/api/shopifyFetchApi.js